/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ro as Ro,
  rec_api as api,
  rec_ii as ii,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function FormularioRol(e) {
  let t = (0, ReactCompiler.c)(53),
    {
      recurso: n,
      singular: r,
      nuevoLabel: i,
      editar: a,
      onClose: o,
      onGuardado: s,
    } = e,
    [c, l] = (0, React.useState)(a?.nombre ?? ``),
    [u, f] = (0, React.useState)(!a || a.activo),
    p = n === `roles`,
    [m, h] = (0, React.useState)(a?.esAdminPlanner ?? !1),
    [_, v] = (0, React.useState)(a?.esAdminSistema ?? !1),
    [y, b] = (0, React.useState)(a?.esTransporte ?? !1),
    [x, S] = (0, React.useState)(a?.esPlanner ?? !0),
    [C, w] = (0, React.useState)(a?.esIncidencias ?? !1),
    [T, E] = (0, React.useState)(a?.esInspecciones ?? !1),
    [D, O] = (0, React.useState)(a?.esOrganigrama ?? !1),
    [k, A] = (0, React.useState)(``),
    [j, M] = (0, React.useState)(!1),
    N;
  t[0] !== u ||
  t[1] !== m ||
  t[2] !== a ||
  t[3] !== p ||
  t[4] !== y ||
  t[5] !== j ||
  t[6] !== T ||
  t[7] !== c ||
  t[8] !== s ||
  t[9] !== n ||
  t[10] !== C ||
  t[11] !== x ||
  t[12] !== D ||
  t[13] !== _
    ? ((N = async function (e) {
        if ((e.preventDefault(), j)) return;
        (M(!0), A(``));
        let t = JSON.stringify(
          p
            ? {
                nombre: c,
                activo: u,
                esAdminPlanner: m || _,
                esAdminSistema: _,
                esTransporte: y || _,
                esPlanner: x || m || _,
                esIncidencias: C || _,
                esInspecciones: T || _,
                esOrganigrama: D,
              }
            : {
                nombre: c,
                activo: u,
              },
        );
        try {
          (a
            ? await api(`/${n}/${a.id}`, {
                method: `PUT`,
                body: t,
              })
            : await api(`/${n}`, {
                method: `POST`,
                body: t,
              }),
            s());
        } catch (e) {
          (A(e.message), M(!1));
        }
      }),
      (t[0] = u),
      (t[1] = m),
      (t[2] = a),
      (t[3] = p),
      (t[4] = y),
      (t[5] = j),
      (t[6] = T),
      (t[7] = c),
      (t[8] = s),
      (t[9] = n),
      (t[10] = C),
      (t[11] = x),
      (t[12] = D),
      (t[13] = _),
      (t[14] = N))
    : (N = t[14]);
  let P = N,
    F = a ? `Editar ${r}` : i,
    I;
  t[15] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((I = (e) => l(e.target.value)), (t[15] = I))
    : (I = t[15]);
  let L;
  t[16] === c
    ? (L = t[17])
    : ((L = (
        <input
          className={Lo}
          placeholder={`Nombre`}
          value={c}
          onChange={I}
          required={!0}
          autoFocus={!0}
        />
      )),
      (t[16] = c),
      (t[17] = L));
  let R;
  t[18] === u
    ? (R = t[19])
    : ((R = <MarcaCarga checked={u} onChange={f} children={`Activo`} />),
      (t[18] = u),
      (t[19] = R));
  let z;
  t[20] !== m ||
  t[21] !== p ||
  t[22] !== y ||
  t[23] !== T ||
  t[24] !== C ||
  t[25] !== x ||
  t[26] !== D ||
  t[27] !== _
    ? ((z = p && (
        <div
          className={`flex flex-col gap-2 rounded-2xl bg-(--panel) p-3`}
          children={[
            <p
              className={`text-xs font-medium text-(--text-h)`}
              children={`Qué puede hacer`}
            />,
            <MarcaCarga
              checked={m || _}
              onChange={h}
              disabled={_}
              children={`Configurar el sistema: etiquetas, plantillas y usuarios`}
            />,
            <MarcaCarga
              checked={_}
              onChange={v}
              children={`Ver el trabajo de toda la empresa, no solo el de su área`}
            />,
            <MarcaCarga
              checked={y || _}
              onChange={b}
              disabled={_}
              children={`Atender los pedidos de movilidad: agrupar y armar órdenes`}
            />,
            <MarcaCarga
              checked={x || m || _}
              onChange={S}
              disabled={m || _}
              children={`Usar el planner: sus tareas, aprobaciones y la organización`}
            />,
            <MarcaCarga
              checked={C || _}
              onChange={w}
              disabled={_}
              children={`Reportar y atender incidencias`}
            />,
            <MarcaCarga
              checked={T || _}
              onChange={E}
              disabled={_}
              children={`Hacer inspecciones y levantar sus observaciones`}
            />,
            <MarcaCarga
              checked={D}
              onChange={O}
              children={`Ver y editar el organigrama, con los datos del personal`}
            />,
            _ && (
              <p
                className={`text-[11px] text-(--text)`}
                children={`Quien ve todo también configura el sistema.`}
              />
            ),
          ]}
        />
      )),
      (t[20] = m),
      (t[21] = p),
      (t[22] = y),
      (t[23] = T),
      (t[24] = C),
      (t[25] = x),
      (t[26] = D),
      (t[27] = _),
      (t[28] = z))
    : (z = t[28]);
  let ee;
  t[29] === k
    ? (ee = t[30])
    : ((ee = k && <p className={`text-sm text-(--error)`} children={k} />),
      (t[29] = k),
      (t[30] = ee));
  let te;
  t[31] === o
    ? (te = t[32])
    : ((te = (
        <button
          type={`button`}
          onClick={o}
          className={zo}
          children={`Cancelar`}
        />
      )),
      (t[31] = o),
      (t[32] = te));
  let B;
  t[33] === j
    ? (B = t[34])
    : ((B =
        j &&
        (0, JSXRuntime.jsx)(ii, {
          className: `mr-1 inline h-4 w-4 animate-spin`,
        })),
      (t[33] = j),
      (t[34] = B));
  let V = a ? `Guardar` : `Crear`,
    H;
  t[35] !== j || t[36] !== V || t[37] !== B
    ? ((H = (
        <button type={`submit`} disabled={j} className={Ro} children={[B, V]} />
      )),
      (t[35] = j),
      (t[36] = V),
      (t[37] = B),
      (t[38] = H))
    : (H = t[38]);
  let ne;
  t[39] !== H || t[40] !== te
    ? ((ne = (
        <div className={`mt-2 flex justify-end gap-2`} children={[te, H]} />
      )),
      (t[39] = H),
      (t[40] = te),
      (t[41] = ne))
    : (ne = t[41]);
  let re;
  t[42] !== P ||
  t[43] !== ne ||
  t[44] !== L ||
  t[45] !== R ||
  t[46] !== z ||
  t[47] !== ee
    ? ((re = (
        <form
          onSubmit={P}
          className={`flex flex-col gap-3`}
          children={[L, R, z, ee, ne]}
        />
      )),
      (t[42] = P),
      (t[43] = ne),
      (t[44] = L),
      (t[45] = R),
      (t[46] = z),
      (t[47] = ee),
      (t[48] = re))
    : (re = t[48]);
  let ie;
  return (
    t[49] !== o || t[50] !== re || t[51] !== F
      ? ((ie = <Modal titulo={F} onClose={o} children={re} />),
        (t[49] = o),
        (t[50] = re),
        (t[51] = F),
        (t[52] = ie))
      : (ie = t[52]),
    ie
  );
}
